













import Component from "vue-class-component";
import Vue from "vue";
import FormAddEditBlock from "./FormAddEditBlock.vue";
import { Prop } from "vue-property-decorator";
import { FormValues } from "@/types";
import { TagInfo } from "@teacherskaya/api-provider/dist/api/TagsProvider";
import { CheckAuthorities } from "@/lib/helpers/componentViewController/decorators";

@Component({
  name: "BlockTagsEdit",
  components: { FormAddEditBlock },
})
export default class BlockTagsEdit extends Vue {
  @Prop({ required: true })
  public tagToEdit!: TagInfo;

  @CheckAuthorities("BlockUserTags", "del_any")
  public allowDelete!: boolean;

  public save(value: FormValues, BlockBaseFormInstance: any) {
    const newTag: TagInfo = {
      id: this.tagToEdit.id,
      slug: this.tagToEdit.slug,
      title: value.title,
    };
    return this.$emit("save", newTag, BlockBaseFormInstance);
  }
}
